import React, { useRef } from 'react';
import { Controller } from 'react-hook-form';
import { useGlobalContext } from '../../contexts/GlobalContext';

//Componentes
import InputBadge from '../../components/inputBadge/InputBadge';
import UserLogsContainer from '../../components/userLogs/UserLogsContainer';

//Estilos
import './Profile.css';

function Profile({ functions, states }) {
    const { masters, user, buildSelectOptions, buildBooleanOptions } =
        useGlobalContext();

    const {
        register,
        control,
        handleSubmit,
        watch,
        setError,
        formState: { errors },
        onSubmit,
        onAddBadge,
        onBadgeDelete,
        setWatchUserLogs,
    } = functions;

    const { watchUserLogs, nroViñedoArray, currentUser } = states;

    const password = useRef({});
    password.current = watch('clave');

    return (
        <div className="profile-container">
            <form className="profile-form" onSubmit={handleSubmit(onSubmit)}>
                <fieldset className="profile-fieldset_1">
                    <h4 className="profile-title">
                        Datos de Registro para Usuario{' '}
                        {
                            masters?.UserTypes?.find(
                                (userType) => userType.id == currentUser?.tipo
                            )?.nombre
                        }
                    </h4>
                    <label className="label-signup">
                        <span>Nombre de Usuario: </span>
                        <input
                            className="signup-input"
                            type="text"
                            {...register('usuario', {
                                required:
                                    user.tipo != 3
                                        ? 'Debe ingresar un nombre de usuario'
                                        : false,
                            })}
                            onKeyPress={(e) => {
                                if (e.target.value.length > 20) {
                                    e.preventDefault();
                                }
                            }}
                        />
                        {errors.usuario && (
                            <small className="form__error">
                                {errors.usuario?.message}
                            </small>
                        )}
                    </label>
                    <label className="label-signup">
                        <span>Nombre: </span>
                        <input
                            className="signup-input"
                            type="text"
                            {...register('nombre', {
                                required: 'Debe ingresar un nombre',
                            })}
                            onKeyPress={(e) => {
                                if (e.target.value.length > 30) {
                                    e.preventDefault();
                                }
                            }}
                        />
                        {errors.nombre && (
                            <small className="form__error">
                                {errors.nombre?.message}
                            </small>
                        )}
                    </label>
                    <label className="label-signup">
                        <span>Apellido: </span>
                        <input
                            className="signup-input"
                            type="text"
                            {...register('apellido', {
                                required: 'Debe ingresar un apellido',
                            })}
                            onKeyPress={(e) => {
                                if (e.target.value.length > 30) {
                                    e.preventDefault();
                                }
                            }}
                        />
                        {errors.apellido && (
                            <small className="form__error">
                                {errors.apellido?.message}
                            </small>
                        )}
                    </label>
                    {currentUser.tipo != 1 && (
                        <label className="label-signup">
                            <span>Tipo Documento: </span>
                            <select {...register('doc_id_tipo')}>
                                {buildSelectOptions('DocumentTypes')?.map(
                                    (op) => {
                                        return (
                                            <option
                                                key={op.name}
                                                value={op.value}
                                            >
                                                {op.title}
                                            </option>
                                        );
                                    }
                                )}
                            </select>
                        </label>
                    )}
                    {currentUser.tipo != 1 && (
                        <label className="label-signup">
                            <span>Nro de Documento: </span>
                            <input
                                className="signup-input"
                                type="number"
                                {...register('doc_id', {
                                    required:
                                        user.tipo != 3
                                            ? 'Debe ingresar un documento de identidad'
                                            : false,
                                })}
                                onKeyPress={(e) => {
                                    if (
                                        !/[0-9]/.test(e.key) ||
                                        e.target.value.length > 15
                                    ) {
                                        e.preventDefault();
                                    }
                                }}
                            />
                            {errors.doc_id && (
                                <small className="form__error">
                                    {errors.doc_id?.message}
                                </small>
                            )}
                        </label>
                    )}
                    <label className="label-signup">
                        <span>Teléfono: </span>
                        <input
                            className="signup-input"
                            type="tel"
                            {...register('celular', {
                                required: 'Debe ingresar un teléfono',
                                pattern: {
                                    value: /^[0-9]*$/,
                                    message: 'Formato incorrecto',
                                },
                                minLength: {
                                    value: 9,
                                    message:
                                        'El teléfono debe tener un mínimo de 9 caracteres',
                                },
                            })}
                            onKeyPress={(e) => {
                                if (e.target.value.length > 20) {
                                    e.preventDefault();
                                }
                            }}
                        />
                        {errors.celular && (
                            <small className="form__error">
                                {errors.celular?.message}
                            </small>
                        )}
                    </label>
                    {currentUser.tipo != 1 && (
                        <label className="label-signup">
                            <span>BPS: </span>
                            <input
                                className="signup-input"
                                type="number"
                                {...register('bps', {
                                    validate: {
                                        length: (v) =>
                                            v.length == 0 ||
                                            (v.length >= 12 &&
                                                v.length <= 15) ||
                                            'El número de BPS debe tener entre 12 y 15 dígitos',
                                    },
                                })}
                                onKeyPress={(e) => {
                                    if (
                                        !/[0-9]/.test(e.key) ||
                                        e.target.value.length > 15
                                    ) {
                                        e.preventDefault();
                                    }
                                }}
                            />
                            {errors.bps && (
                                <small className="form__error">
                                    {errors.bps?.message}
                                </small>
                            )}
                        </label>
                    )}
                    {currentUser.tipo != 1 && (
                        <label className="label-signup">
                            <span>RUT: </span>
                            <input
                                className="signup-input"
                                type="number"
                                {...register('rut', {
                                    validate: {
                                        length: (v) =>
                                            v.length == 0 ||
                                            (v.length >= 12 &&
                                                v.length <= 15) ||
                                            'El número de RUT debe tener entre 12 y 15 dígitos',
                                    },
                                })}
                                onKeyPress={(e) => {
                                    if (
                                        !/[0-9]/.test(e.key) ||
                                        e.target.value.length > 15
                                    ) {
                                        e.preventDefault();
                                    }
                                }}
                            />
                            {errors.rut && (
                                <small className="form__error">
                                    {errors.rut?.message}
                                </small>
                            )}
                        </label>
                    )}
                    <label className="label-signup">
                        <span>Correo: </span>
                        <input
                            className="signup-input"
                            type="email"
                            {...register('correo', {
                                required: 'Debe ingresar un correo',
                            })}
                            onKeyPress={(e) => {
                                if (e.target.value.length > 50) {
                                    e.preventDefault();
                                }
                            }}
                        />
                        {errors.correo && (
                            <small className="form__error">
                                {errors.correo?.message}
                            </small>
                        )}
                    </label>
                    {currentUser.tipo != 1 && (
                        <label className="label-signup">
                            <span>Dirección: </span>
                            <input
                                type="text"
                                className="signup-input"
                                {...register('direccion', {
                                    required:
                                        user.tipo != 3
                                            ? 'Debe ingresar una dirección'
                                            : false,
                                })}
                                onKeyPress={(e) => {
                                    if (e.target.value.length > 50) {
                                        e.preventDefault();
                                    }
                                }}
                            />
                            {errors.direccion && (
                                <small className="form__error">
                                    {errors.direccion?.message}
                                </small>
                            )}
                        </label>
                    )}
                </fieldset>
                {user.tipo === 3 && (
                    <fieldset className="profile-fieldset_2">
                        <h4 className="profile-title">
                            Administración del Usuario
                        </h4>
                        {/* <label className="label-signup">
                            <span>Nivel de Usuario: </span>
                            <select
                                className="signup-input"
                                {...register('tipo')}
                            >
                                {buildSelectOptions('UserTypes')?.map((op) => {
                                    return (
                                        <option key={op.name} value={op.value}>
                                            {op.title}
                                        </option>
                                    );
                                })}
                            </select>
                            {errors.tipo && (
                                <small className="form__error">
                                    {errors.tipo?.message}
                                </small>
                            )}
                        </label> */}
                        <label className="label-signup">
                            <span>Correo Confirmado: </span>
                            <select
                                className="signup-input"
                                {...register('confirmado', {})}
                            >
                                {buildBooleanOptions()?.map((op) => {
                                    return (
                                        <option key={op.name} value={op.value}>
                                            {op.title}
                                        </option>
                                    );
                                })}
                            </select>
                            {errors.confirmado && (
                                <small className="form__error">
                                    {errors.confirmado?.message}
                                </small>
                            )}
                        </label>
                        <label className="label-signup">
                            <span>Estado de la cuenta: </span>
                            <select {...register('habilitado')}>
                                {buildSelectOptions('HabilitationTypes')?.map(
                                    (op) => {
                                        return (
                                            <option
                                                key={op.name}
                                                value={op.value}
                                            >
                                                {op.title.replace('_', ' ')}
                                            </option>
                                        );
                                    }
                                )}
                            </select>
                            {errors.habilitado && (
                                <small className="form__error">
                                    {errors.habilitado?.message}
                                </small>
                            )}
                        </label>
                        <label className="label-signup">
                            <span>Clave: </span>
                            <input
                                className="signup-input"
                                type="password"
                                autoComplete="off"
                                {...register('clave', {
                                    minLength: {
                                        value: 8,
                                        message:
                                            'La clave debe tener un mínimo de 8 caracteres',
                                    },
                                    pattern: {
                                        value: /(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&#]/,
                                        message:
                                            'La clave debe tener al menos una minúscula, una mayúscula, un número y un caracter especial [@$!%*?&#]',
                                    },
                                })}
                                onKeyPress={(e) => {
                                    if (e.target.value.length > 20) {
                                        e.preventDefault();
                                    }
                                }}
                            />
                            {errors.clave && (
                                <small className="form__error">
                                    {errors.clave?.message}
                                </small>
                            )}
                        </label>
                        <label className="label-signup">
                            <span>Confirmar clave: </span>
                            <input
                                className="signup-input"
                                type="password"
                                autoComplete="off"
                                {...register('confirmPassword', {
                                    validate: {
                                        passwordMatch: (value) =>
                                            value === password.current ||
                                            'Las claves no coinciden',
                                    },
                                })}
                                onKeyPress={(e) => {
                                    if (e.target.value.length > 20) {
                                        e.preventDefault();
                                    }
                                }}
                            />
                            {errors.confirmPassword && (
                                <small className="form__error">
                                    {errors.confirmPassword?.message}
                                </small>
                            )}
                        </label>
                    </fieldset>
                )}
                {user.tipo === 3 &&
                    currentUser.tipo !== 3 &&
                    currentUser.id !== user.id && (
                        <fieldset className="profile-fieldset_3">
                            <h4 className="profile-title">
                                Viñedos Asignados a este Usuario
                            </h4>
                            <label className="label-signup">
                                <span>Números de Viñedo: </span>
                                <Controller
                                    name="nrosViñedos"
                                    control={control}
                                    // rules={{
                                    //     validate: {
                                    //         requiredVineyards: () =>
                                    //             nroViñedoArray.length > 0 ||
                                    //             'Debe ingresar al menos un número de viñedo',
                                    //     },
                                    // }}
                                    render={() => (
                                        <InputBadge
                                            type={'number'}
                                            dataArray={nroViñedoArray}
                                            onAdd={onAddBadge}
                                            onDelete={onBadgeDelete}
                                        />
                                    )}
                                />
                                {errors.nrosViñedos && (
                                    <small className="form__error">
                                        {errors.nrosViñedos.message}
                                    </small>
                                )}
                            </label>
                        </fieldset>
                    )}
                <div className="profile-footer">
                    <button type="submit" className="btn btn-primary">
                        Guardar
                    </button>
                </div>
            </form>
            {user.tipo === 3 && (
                <fieldset className="profile-fieldset_4">
                    <h4 className="profile-title">Historial del Usuario</h4>
                    <button
                        className="btn btn-primary profile-history_btn"
                        onClick={() => setWatchUserLogs(!watchUserLogs)}
                    >
                        {!watchUserLogs ? 'Ver Historial' : 'Ocultar Historial'}
                    </button>
                    {watchUserLogs && <UserLogsContainer />}
                </fieldset>
            )}
        </div>
    );
}

export default Profile;
